import classNames from 'classnames';
import { CSSProperties, FC } from 'react';

import * as styles from './index.module.less';

export interface RangeInputProps {
  className?: string;
  style?: CSSProperties;
  colors?: [string, string?];
  value: number;
  onChange: (value: number) => any;
}

export const RangeInput: FC<RangeInputProps> = ({
  className,
  style,
  colors,
  value,
  onChange
}) => (
  <div
    className={classNames(styles['range-wrap'], className)}
    style={{
      ...style,
      backgroundSize: `${value}% 100%`,
      backgroundImage: `linear-gradient(to right, ${
        colors[1] ? colors[0] : 'transparent'
      } 0%, ${colors[1] || colors[0]} ${value}%)`
    }}
  >
    <input
      type="range"
      value={value}
      min={0}
      max={100}
      onChange={({ currentTarget }) => onChange(+currentTarget.value)}
    />
  </div>
);
